import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { HealthCheckResult, HealthService } from './health.service';

@Component({
    selector: 'app-health-check',
    standalone: true,
    imports: [CommonModule, MatProgressSpinnerModule],
    templateUrl: './health-check.component.html',
    styleUrl: './health-check.component.scss',
})
export class HealthCheckComponent implements OnInit {
    private healthService = inject(HealthService);

    loading = false;
    result: HealthCheckResult | null = null;

    ngOnInit(): void {
        this.runCheck();
    }

    runCheck(): void {
        this.loading = true;
        this.healthService.check().subscribe((res) => {
            this.result = res;
            this.loading = false;
        });
    }
}
